import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Page, ClienteSimplificado } from '../../../models/cadastro.model';
import { CadastroService } from '../../../services/cadastro.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalStateService } from '../../../services/modaState.service';

@Component({
  selector: 'app-cliente-modal',
  imports: [CommonModule, FormsModule],
  standalone: true,
  templateUrl: './cliente-modal.html',
  styleUrl: './cliente-modal.css'
})
export class ClienteModal implements OnInit {

  ngOnInit(): void {
    this.resetForm();
  }

  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<ClienteSimplificado | undefined>();

  modalStateService = inject(ModalStateService);
  cadastroService = inject(CadastroService);
  selectedCliente: ClienteSimplificado = this.getNewCliente();

  termo: string = '';
  clientePage: Page<ClienteSimplificado> | undefined;
  page = 0;
  size = 5;

  // Pagination
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  search() {
    this.cadastroService.getClienteSimplificado(this.termo, this.page, this.size).subscribe(response => {
      this.clientePage = response;
      this.updatePageNumbers();
    });
  }

  selectCliente(cliente: ClienteSimplificado): void {
    this.selectedCliente = cliente;
  }

  inserirCliente(): void {
    this.isOpen = false;
    this.modalStateService.close(this.selectedCliente);
    this.closeModal.emit(this.selectedCliente);
  }

  onPageChange(page: number) {
    this.setPage(page);
  }

  setPage(page: number): void {
    if (page < 0 || (this.clientePage && page >= this.clientePage.totalPages)) {
      return;
    }
    this.page = page;
    this.search();
  }

  updatePageNumbers(): void {
    if (!this.clientePage) {
      return;
    }

    const totalPages = this.clientePage.totalPages;
    const currentPage = this.page;
    const maxPages = this.maxPagesToShow;

    let startPage: number, endPage: number;

    if (totalPages <= maxPages) {
      startPage = 0;
      endPage = totalPages - 1;
    } else {
      const maxPagesBeforeCurrent = Math.floor(maxPages / 2);
      const maxPagesAfterCurrent = Math.ceil(maxPages / 2) - 1;

      if (currentPage <= maxPagesBeforeCurrent) {
        startPage = 0;
        endPage = maxPages - 1;
      } else if (currentPage + maxPagesAfterCurrent >= totalPages) {
        startPage = totalPages - maxPages;
        endPage = totalPages - 1;
      } else {
        startPage = currentPage - maxPagesBeforeCurrent;
        endPage = currentPage + maxPagesAfterCurrent;
      }
    }

    this.pages = Array.from(Array((endPage - startPage) + 1).keys()).map(i => startPage + i);
  }

  public onClose(): void {
    this.closeModal.emit(undefined);
  }

  public resetForm(): void {
    this.termo = '';
  }

  private getNewCliente(): ClienteSimplificado {
    return {
      id: 0,
      nomeRazaoSocial: '',
      cpfCnpj: '',
      nomeFantasia: ''
    };
  }
}
